export default __webpack_public_path__ + "static/31-7bf8b1d80c93cb7a9a3a7af9553a7416.gif";